export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const GECCO_URL = process.env.REACT_APP_BASE_URL;
export const FC_URL = process.env.REACT_APP_BASE_URL;
export const S3_URL = process.env.REACT_APP_S3_URL;

export const API_VERSION = "/api/v1";
export const PORTAL_KEY = "/portal" + API_VERSION;
export const VDS_KEY = "/vds" + API_VERSION;
export const BOA_KEY = "/boa" + API_VERSION;
export const FT_KEY = "/ft" + API_VERSION;
export const SQW_KEY = "/sqw" + API_VERSION;
export const RESULT_ANALYSIS_KEY = "/resultanalysis" + API_VERSION;

export const ACTIVITY_URL = VDS_KEY + "/activity";
export const BANK_GROUPS_URL = VDS_KEY + "/bankgroups";
export const BANK_GROUP_URL = VDS_KEY + "/bankgroup";
export const COMMON_URL = VDS_KEY + "/common";
export const USERS_URL = VDS_KEY + "/users";
export const USER_URL = VDS_KEY + "/user";
export const API_URL="/apiuser"

export const CONSULTANT_URL = VDS_KEY + "/consultant";

// constants
export const BANKS = "banks";
export const REMAINING_BANKS = "remainingBanks";
export const BRANCHES = "branches";
export const BRANCH_NAMES = "branchNames";
export const PRODUCTS = "products";
export const SEARCH_STRING = "SearchString";
export const ORDERBY = "OrderBy";
export const FILTER = "Filter";
export const BANK_GROUP_ID = "BankGroupId";
export const ORDER_TYPE = "OrderType";
export const BRANCH_DATA = "branch-data";
export const PAYMENT_INFO = "payment-informantion";
export const CREATE_CONSULTANT = "team-member";
export const TEAM_MEMBERS = "team-members";
export const BRANCH_DOCUMENTS = "documents";
export const BRANCH_PRODUCT_DATA = "branch-product-detail";
export const CONSULTANT = "consultant";
export const PRODUCT_ID = "productId";
export const OTP = "otp-configuration";
export const BRANCH_LOGO = "file";
export const MEDIA = "media";
export const ACCOUNTS = "accounts";
export const PAYMENTS="payment";
// User profile
export const PROFILE_IMAGE = USER_URL + "/profile-picture";
export const RESEND_CREDs="resend-credentials"
export const REMOVE_CREDs="remove-credentials"
// activity
export const activityUrl = {
  futureCareUsers: ACTIVITY_URL + "/futureCare/users",
  geccoUsers: ACTIVITY_URL + "/gecco/users",
  usersCount: ACTIVITY_URL + "/users-count",
};
// bank
export const getBanksUrl = (bankgroupId) => {
  return `${BANK_GROUPS_URL}/${bankgroupId}/${BANKS}?timestamp=${Date.now()}`;
};

export const getRemainingBanksUrl = (bankgroupId) => {
  return `${BANK_GROUPS_URL}/${bankgroupId}/${BANKS}?${REMAINING_BANKS}=${true}`;
};
// branch
export const getBranchesUrl = (bankgroupId) => {
  return `${BANK_GROUPS_URL}/${bankgroupId}/${BANKS}/${BRANCHES}`;
};
export const getBranchNamesUrl = (bankgroupId, bankId) => {
  return `${BANK_GROUPS_URL}/${bankgroupId}/${BANKS}/${bankId}/branchNames`;
};
export const addBranchUrl = (bankgroupId, bankId) => {
  return `${BANK_GROUPS_URL}/${bankgroupId}/${BANKS}/${bankId}/branches`;
};
export const getBranchDetailUrl = (bankgroupId, bankId, branchId) => {
  return `${BANK_GROUPS_URL}/${bankgroupId}/${BANKS}/${bankId}/${BRANCHES}/${branchId}`;
};
export const branchDataUrl = (bankGroupId, bankId, branchId, productId) => {
  return `${BANK_GROUPS_URL}/${bankGroupId}/${BANKS}/${bankId}/${BRANCHES}/${branchId}/${PRODUCTS}/${productId}`;
};

export const fetchBranchLogoUrl = (imageURL) => {
  return `${BASE_URL}${VDS_KEY}/${MEDIA}/file?mediaPath=${imageURL}`;
};

// product two factor activation

export const otpActivationUrl = (productId) => {
  return `${VDS_KEY}/${PRODUCTS}/${productId}/${OTP}`;
};

// branchProduct
export const branchProductsUrl = (bankgroupId, bankId, branchId) => {
  return `${BANK_GROUPS_URL}/${bankgroupId}/${BANKS}/${bankId}/${BRANCHES}/${branchId}/${PRODUCTS}`;
};

// branch product payment information

export const branchProductPaymentInfoUrl = (
  bankgroupId,
  bankId,
  branchId,
  productId
) => {
  return `${BANK_GROUPS_URL}/${bankgroupId}/${BANKS}/${bankId}/${BRANCHES}/${branchId}/${PRODUCTS}/${productId}/${ACCOUNTS}`;
};
export const branchProductPaymentInfoUrlNew = (
  bankgroupId,
  bankId,
  branchId,
) => {
  return `${BANK_GROUPS_URL}/${bankgroupId}/${BANKS}/${bankId}/${BRANCHES}/${branchId}/${PAYMENTS}`;
};

export const updateFormDataUrl = (bankgroupId, bankId, branchId, productId) => {
  return `${BANK_GROUPS_URL}/${bankgroupId}/${BANKS}/${bankId}/${BRANCHES}/${branchId}/${PRODUCTS}/${productId}/${TEAM_MEMBERS}`;
};

export const getTeamListUrl = (
  bankgroupId,
  bankId,
  branchId,
  productId,
  pageNumber
) => {
  return `${CONSULTANT_URL}?${BANK_GROUP_ID}=${bankgroupId}&bankId=${bankId}&branchId=${branchId}&productId=${productId}&PageNumber=${pageNumber}&PageSize=${10}`;
};

export const deleteTeamDataUrl = (
  bankgroupId,
  bankId,
  branchId,
  productId,
  teamMemberId
) => {
  return `${BANK_GROUPS_URL}/${bankgroupId}/${BANKS}/${bankId}/${BRANCHES}/${branchId}/${PRODUCTS}/${productId}/${TEAM_MEMBERS}/${teamMemberId}`;
};

export const updateTeamDataUrl = (
  bankgroupId,
  bankId,
  branchId,
  productId,
  teamMemberId
) => {
  return `${BANK_GROUPS_URL}/${bankgroupId}/${BANKS}/${bankId}/${BRANCHES}/${branchId}/${PRODUCTS}/${productId}/${TEAM_MEMBERS}/${teamMemberId}`;
};

// check branch data status

export const checkBranchDataStatus = (bankgroupId, bankId, branchId) => {
  return `${BANK_GROUPS_URL}/${bankgroupId}/${BANKS}/${bankId}/${BRANCHES}/${branchId}/${BRANCH_DOCUMENTS}`;
};

// common
export const commonUrl = {
  gridConfigurations: VDS_KEY + "/grid-configurations",
  branches: COMMON_URL + "/branches",
  contactEmail: VDS_KEY + "/contact",
};
// user
export const userUrl = {
  profile: USER_URL + "/profile",
  authenticate: USERS_URL + "/authentication",
  logout: USERS_URL + "/logout",
  validateLink: USERS_URL + "/Validate-link",
  setPassword: USERS_URL + "/password",
  forgetPassword: USERS_URL + "/forgot-password",
  userClaims: USERS_URL + "/claims",
  inviteAPI: USERS_URL + "/apiuser/invite",
  invite: USERS_URL + "/invite",
  roles: USERS_URL + "/roles",
  allClaims: "/claims",
  rolesAllowed: USERS_URL + "/roles-allowed",
  usersProfilePicture: "/profile-picture",
  resendInvite: USERS_URL + "/resend-invite",
  changePassword: USER_URL + "/password",
};

export const getUsersProfilePictureUrl = (id) => {
  return `${BASE_URL}${USERS_URL}/${id}${userUrl.usersProfilePicture}`;
};
export const postResendCredsUrl = (id) => {
  return `${USERS_URL}${API_URL}/${id}/${RESEND_CREDs}`;
};
export const postRemoveCredsUrl = (id) => {
  return `${USERS_URL}${API_URL}/${id}/${REMOVE_CREDs}`;
};

export const getResendLinkUrl = (id) => {
  return `${userUrl.resendInvite}?inviteUserId=${id}`;
};
//  gecco urls
export const geccoUrl = {
  uploadedFilesGraph: RESULT_ANALYSIS_KEY + "/BwaFile/all-uploadedfiles-graph",
};

//  fc urls
export const futureCareUrl = {
  boaChartData: BOA_KEY + "/boa/chart-data/",
  familyTreeChartData: FT_KEY + "/family-tree/chart-data/",
  statusQuoChartData: SQW_KEY + "/statuq-quo/chart-data/",
};

//urls to redirect
export const loginUrl = "dashboard.vds.ilidigital-soft.com";
export const imprintEmailAdress = "info@volksbank.solutions";
export const privacyPolicyRoute = "/datenschutzhinweise";
export const AGB = "/AGB";
export const linkedInProfileUrl = "https://www.linkedin.com/company/85849014";
